<template>
    <div v-if="commentSuggestion" class="relative w-full mb-9 mt-20 md:mt-24 xl:mt-32 items-center flex">
        <div
            class="gray-rectangle flex-col sm:flex-row gap-8 rounded-[28px] pt-8 px-6 pb-6 flex md:py-10 md:px-8 lg:py-10 lg:pl-8 lg:pr-12 items-center w-full">
            <img class="hidden sm:block" alt="question mark" src="../../../images/messaging.jpg" />
            <p class="font-trap text-center sm:text-left leading-7 font-semibold text-xl xl:text-2xl">Give us your impressions about this article</p>
            <button @click="showCommentForm" class="btn-primary uppercase w-full sm:w-52 text-sm transition duration-200">
                leave a comment
            </button>
        </div>
    </div>
    <div v-if="commentForm"
        class="flex w-full mb-9 mt-20 md:mt-24 xl:mt-32 comment-bg borderRadius border border-grayBorder flex-col md:pt-6 md:px-10 md:pb-10 p-6">
        <div class="flex mb-6 justify-between">
            <p class="uppercase text-base md:text-[18px] font-bold text-grayText">add your comment</p>
            <svg @click="showLeaveCommentSuggestion" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="{1.5}" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </div>
        <form @submit.prevent="submit">
            <div class="relative mb-8">
                <input v-model="form.name" type="text" id="name"
                    class="block px-4 pb-4 w-full rounded-[14px] focus:border focus:border-grayCase border border-grayInContainer pt-3 appearance-none focus:bg-transparent focus:outline-none focus:ring-0 peer"
                    placeholder=" " />
                <label for="name"
                    class="absolute text-sm text-gray duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-inputLabel peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Name*</label>
            </div>
            <div class="relative">
                <textarea v-model="form.comment" required type="text" id="comment"
                    class="block outline-none px-4 pb-4 w-full h-40 rounded-[14px] border border-grayInContainer pt-3 focus:border focus:border-grayCase appearance-none focus:outline-none focus:ring-0 peer"
                    placeholder=" " />
                <label for="comment"
                    class="absolute text-sm text-gray duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-inputLabel peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Enter
                    your comment*</label>
            </div>
            <button type="submit" class="btn-primary bg-mainColor uppercase mt-8 w-full sm:w-56">
                leave comment
            </button>
        </form>
    </div>
    <div v-for="(comment, index) in comments" :key="index">
        <div v-if="comment.showReplyForm"
            class="flex w-full mb-9 mt-20 md:mt-24 xl:mt-32 comment-bg borderRadius border border-grayBorder flex-col md:pt-6 md:px-10 md:pb-10 p-6">
            <div class="flex mb-6 justify-between">
                <p class="uppercase text-base md:text-[18px] font-bold text-grayText">add your comment</p>
                <svg @click="showLeaveCommentSuggestion(index)" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="{1.5}" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
            <form @submit.prevent="submitReply(index)">
                <div class="relative mb-8">
                    <input v-model="form.name" type="text" id="name"
                        class="block px-4 pb-4 w-full rounded-[14px] focus:border focus:border-grayCase border border-grayInContainer pt-3 appearance-none focus:bg-transparent focus:outline-none focus:ring-0 peer"
                        placeholder=" " />
                    <label for="name"
                        class="absolute text-sm text-gray duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-inputLabel peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Name*</label>
                </div>
                <div class="relative">
                    <textarea v-model="form.comment" required type="text" id="comment"
                        class="block outline-none px-4 pb-4 w-full h-40 rounded-[14px] border border-grayInContainer pt-3 focus:border focus:border-grayCase appearance-none focus:outline-none focus:ring-0 peer"
                        placeholder=" " />
                    <label for="comment"
                        class="absolute text-sm text-gray duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-inputLabel peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Enter
                        your comment*</label>
                </div>
                <button type="submit" class="btn-primary bg-mainColor uppercase mt-8 w-full sm:w-56">
                    Leave comment
                </button>
            </form>
        </div>
    </div>
    <div class="flex flex-col">
        <div class="flex mb-5 justify-between">
            <h2 class="sm:text-[24px] text-xl font-semibold font-trap">Comments</h2>
            <p class="font-trap text-lg sm:text-[20px] font-semibold text-gray">{{ getTotalCommentCount() }} Comments</p>
        </div>
        <div v-for="(comment, index) in comments" :key="index" class="flex flex-col">
            <div class="flex flex-col mb-12">
                <div class="flex mb-4 w-full items-center justify-between">
                    <div class="flex items-center">
                        <img :src="comment.imgSrc" />
                        <div class="flex ml-5 flex-col">
                            <h4 class="text-xs font-semibold text-grayText">{{ comment.name }}</h4>
                            <p class="text-gray font-medium text-[10px]">{{ comment.date }}</p>
                        </div>
                    </div>
                    <button @click="showReplyForm(index)"
                        class="hover:bg-lightOrange text-blackColor outline outline-1 h-12 font-bold w-32 text-sm p-2 outline-mainColor rounded-xl transition duration-200">
                        REPLY
                    </button>
                </div>
                <p class="font-medium text-sm sm:text-[16px] leading-6 text-[#3D3F56]">{{ comment.text }}</p>
            </div>
            <div class="ml-6 md:ml-12 xl:ml-20">
                <div v-for="(reply, rIndex) in comment.replies" :key="rIndex" class="flex flex-col sm:mb-4">
                    <div class="flex mb-4  w-full flex-col">
                        <div class="flex items-center">
                            <img :src="reply.imgSrc" />
                            <div class="flex ml-5 flex-col">
                                <h4 class="text-xs font-semibold text-grayText">{{ reply.name }}</h4>
                                <p class="text-gray font-medium text-[10px]">{{ reply.date }}</p>
                            </div>
                        </div>
                        <p class="font-medium mt-4 text-[#3D3F56]">{{ reply.text }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CommentsArticle",
    data() {
        return {
            commentForm: false,
            commentSuggestion: true,
            form: {
                name: "",
                comment: "",
            },
            comments: [
                {
                    name: "Brooklyn Simmons",
                    date: "08.10.2023 at 09.41",
                    text: "This article has compiled the whole flow of e-learning & detailed out the steps in a precise way! It has been very helpful to understand the end-to-end process!",
                    imgSrc: "../../../images/comment-img1.png",
                    showReplyForm: false,
                    replies: []
                },
                {
                    name: "Jenny Wilson",
                    date: "05.10.2023 at 09.41",
                    text: "A very informative blog. This discusses right from scratch. Building a website for e-learning purpose is made easy. The features listed out enhanced my knowledge. Thank you.",
                    imgSrc: "../../../images/comment-img2.png",
                    showReplyForm: false,
                    replies: []
                },
                {
                    name: "Kathryn Murphy",
                    date: "04.10.2023 at 09.41",
                    text: "Wow! An interesting read.",
                    imgSrc: "../../../images/comment-img3.png",
                    showReplyForm: false,
                    replies: [
                        {
                            name: "Marvin McKinney",
                            date: "04.10.2023 at 09.48",
                            text: "Totally agree with you. It's amazing!",
                            imgSrc: "../../../images/comment-img4.png",
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        showCommentForm() {
            this.commentForm = true;
            this.commentSuggestion = false;
        },
        showLeaveCommentSuggestion(commentIndex) {
            this.commentForm = false;
            this.commentSuggestion = true;
            this.comments[commentIndex].showReplyForm = false;
        },
        showReplyForm(commentIndex) {
            this.commentSuggestion = false;
            this.commentForm = false;
            this.comments[commentIndex].showReplyForm = true;
        },

        submitReply(commentIndex) {
            const newReply = {
                name: this.form.name,
                date: new Date().toLocaleString(),
                text: this.form.comment,
                imgSrc: "../../../images/comment-img4.png",
            };

            this.comments[commentIndex].replies.push(newReply);

            this.form.name = "";
            this.form.comment = "";
            this.comments[commentIndex].showReplyForm = false;
            this.commentSuggestion = true;
        },
        submit() {
            const newComment = {
                name: this.form.name,
                date: new Date().toLocaleString(),
                text: this.form.comment,
                imgSrc: "../../../images/comment-img4.png",
                showReplyForm: false,
                replies: []
            };

            this.comments.push(newComment);

            this.form.name = "";
            this.form.comment = "";
            this.commentForm = false;
            this.commentSuggestion = true;
        },
        getTotalCommentCount() {
            let count = 0;
            this.comments.forEach((comment) => {
                count += 1;
                if (comment.replies) {
                    count += comment.replies.length;
                }
            });
            return count;
        },
    },
};
</script>
